import React from 'react';
import './SplashPage.css';

const SplashPage = () => {
  return (
    <div className="splash-container">
      <div className="splash-content">
        <div className="splash-message">
          <p>
            The Storehouse is currently closed for our annual physical inventory count until Thursday, July 10th. During this period, we're unable to process or receive any orders. If you have any questions, kindly submit a help desk ticket by following this link: <a href="https://prisonfellowship.freshservice.com/support/home" target="_blank" rel="noopener noreferrer">https://prisonfellowship.freshservice.com/support/home</a>
          </p>
          <p>Thank you!</p>
        </div>
      </div>
    </div>
  );
};

export default SplashPage; 